import Home from '@/components/page/Home';
import Feed from '@/components/page/Feeds';
import Profile from '@/components/page/Profile';
import Settings from '@/components/page/Settings';
import TakerSelector from '@/components/page/TakerSelector';
// Routes
const routes = [
    {
        path: '',
        name: 'dashboard',
        component: Home
    },
    {
        path: '/select-taker',
        name: 'select-taker',
        component: TakerSelector
    },
    {
        path: '/feed',
        name: 'feed',
        component: Feed
    },
    {

        path: '/manage-profile',
        name: 'manage-profile',
        component: Profile
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings
    },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js